import { AdminGuard } from './../../../core/admin.gaurd';
import { AuthGuard } from './../../../core/auth.gaurd';
import { Router } from '@angular/router';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { PopoverContentComponent } from 'ngx-smart-popover';
import { AuthService } from 'src/app/core/auth.service'; 
import { MenuItem } from 'primeng/api';
import { ApplicationUserService } from 'src/app/core/applicationuser.service';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { catchError, map } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input('title') title: string="";
  @Input('subTitle') subTitle: string="";
  
  @ViewChild('menuPopover')
  menuPopover!: PopoverContentComponent;

  constructor(
    private authService: AuthService,
    private router: Router,
    private userService: ApplicationUserService,
    private afAuth: AngularFireAuth
  ) { }
  userDetails: any;
  logout(){
    this.authService.doLogout()
    .then((res) => {
      this.router.navigate(['/login']);
    }, (error) => {
      console.log("Logout error", error);
    });
  }
  sidebarVisible =false;
  isAdmin :boolean = false;
  items!: MenuItem[];
  helpOverlayVisible: boolean = false;
  ngOnInit() {
    this.items = [
      {
        label: 'SDS Search',
        icon: 'pi pi-search',
        routerLink: ['/search'], // Add the router link for the 'SDS Search' page
      },
      {
        label: 'Application Users',
        icon: 'pi pi-user',
        expanded: true,
        items: [
          {
            label: 'New',
            icon: 'pi pi-user-plus',
            routerLink: ['/application-user-new'], // Add the router link for the 'New' page
          },
          {
            label: 'List',
            icon: 'pi pi-users',
            routerLink: ['/application-user-list'], // Add the router link for the 'List' page
          },
        ],
      },
      {
        label: 'Activity Tracker',
        icon: 'pi pi-eye',
        expanded: true,
        items: [
          {
            label: 'Login Reports',
            icon: 'pi pi-sign-in',
            routerLink: ['/login-report'], // Add the router link for the 'New' page
          },
          {
            label: 'Search Reports',
            icon: 'pi pi-search-plus',
            routerLink: ['/search-sds-report'], // Add the router link for the 'List' page
          },
          {
            label: 'Download Reports',
            icon: 'pi pi-download',
            routerLink: ['/download-report'], // Add the router link for the 'List' page
          },
        ],
      },

    ];
    this.checkForAdminStatus();
  }
  checkForAdminStatus(){
    this.afAuth.idTokenResult.subscribe(idTokenResult => {
      if (idTokenResult && idTokenResult.claims?.['role'] == 'Admin') {
        this.isAdmin = true;
      } else {
        this.isAdmin = false;
      }
    });
}

routeToSearchSDSPage(){
  this.router.navigate(['/search']);
}
showHelpPanel() {
  this.helpOverlayVisible = true;
}
visible: boolean = false;

showDialog() {
    this.visible = true;
}
hideDialog() {
  this.visible = false;
}

}
